import React from 'react';

/** Check if string looks like HTML (contains tags) */
export const isHtml = (str: string): boolean => {
  if (!str || typeof str !== 'string') return false;
  return /<[a-z][\s\S]*>/i.test(str);
};

/** Strip HTML tags and return plain text (e.g. for PDF or preview) */
export const stripHtml = (html: string): string => {
  if (!html || typeof html !== 'string') return '';
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .trim();
};

/** Render content that may be HTML or plain text */
export const renderRichContent = (
  content: string | undefined | null,
  className?: string
): React.ReactNode => {
  if (!content || !content.trim()) return null;
  if (isHtml(content)) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: content }}
        style={{ wordBreak: 'break-word' }}
      />
    );
  }
  return (
    <div className={className}>
      {content.split('\n').filter((p) => p.trim()).map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  );
};
